import { ALLOWED_BUTTON_VARIANTS, isString, sanitizeAllowedString, sanitizeBindable, sanitizeBoolean, sanitizeFormattableBindable, sanitizeString } from './helpers';
function isFieldValue(v) {
  return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || Array.isArray(v) || typeof v === 'object' && v !== null;
}
function sanitizeFieldValue(v) {
  return isFieldValue(v) ? v : undefined;
}
function sanitizeAdditionalParams(value) {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) {
    return undefined;
  }
  const result = {};
  for (const [k, v] of Object.entries(value)) {
    const sanitized = sanitizeBindable(v, sanitizeFieldValue);
    if (sanitized !== undefined) result[k] = sanitized;
  }
  return Object.keys(result).length > 0 ? result : undefined;
}
const PHRASING_TYPES = new Set(['Icon', 'SvgIcon', 'Text']);
function isPhrasingType(type) {
  return typeof type === 'string' && PHRASING_TYPES.has(type);
}
function sanitizeContentArray(raw, sanitizeElement) {
  if (!Array.isArray(raw)) return undefined;
  const items = raw.filter(item => typeof item === 'object' && item !== null && !Array.isArray(item) && isPhrasingType(item.type)).map(item => sanitizeElement(item)).filter(item => item !== null);
  return items.length > 0 ? items : undefined;
}
export function sanitizeButton(el, sanitizeElement) {
  const label = sanitizeFormattableBindable(el.label, sanitizeString);
  if (!label) return null;
  if (!isString(el.callAction)) return null;
  return {
    type: 'Button',
    label,
    callAction: el.callAction,
    additionalParams: sanitizeAdditionalParams(el.additionalParams),
    variant: sanitizeBindable(el.variant, v => sanitizeAllowedString(v, ALLOWED_BUTTON_VARIANTS)),
    disabled: sanitizeBindable(el.disabled, sanitizeBoolean),
    fullWidth: sanitizeBindable(el.fullWidth, sanitizeBoolean),
    content: sanitizeContentArray(el.content, sanitizeElement)
  };
}